import React from "react";
import Weather from "./Weather";

function App() {
    return <Weather />;
}

export default App;
